export const REQUEST = 'Admin/UserPrizes/REQUEST';
export const SUCCESS = 'Admin/UserPrizes/SUCCESS';
export const ERROR = 'Admin/UserPrizes/ERROR';

export const SET = 'Admin/UserPrizes/SET';
export const UPDATED = 'Admin/UserPrizes/UPDATED';